import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";

export default function AuthCallback() {
  const nav = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      nav("/login", { replace: true });
      return;
    }
    const session_id = decodeURIComponent(match[1]);

    api.post("/auth/session", { session_id }, { withCredentials: true })
      .then(() => {
        // Clean up URL fragment
        window.history.replaceState(null, "", window.location.pathname);
        nav("/admin/filings", { replace: true });
      })
      .catch((err) => {
        const detail = err?.response?.data?.detail || "Login failed";
        nav(`/login?error=${encodeURIComponent(detail)}`, { replace: true });
      });
  }, [nav]);

  return (
    <div className="bb-container py-20 text-center bb-overline text-bb-slate" data-testid="auth-callback">
      Completing sign in…
    </div>
  );
}
